import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { Loader } from '@/components/common/Loader'

const SettingsPage = lazy(() =>
  import('@/features/city-clerk/settings/pages/SettingsPage/SettingsPage').then(
    (m) => ({ default: m.default }),
  ),
)

export const Route = createFileRoute('/(app)/city-clerk/settings')({
  component: SettingsRoute,
})

function SettingsRoute() {
  return (
    <Suspense
      fallback={
        <div className="h-screen flex items-center justify-center">
          <Loader size="lg" />
        </div>
      }
    >
      <SettingsPage />
    </Suspense>
  )
}
